import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GoogleAuthCallback from "./components/GoogleAuthCallback";
import AdminActingAsHostBanner from "./components/AdminActingAsHostBanner";
import HomePage from "./pages/HomePage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import BookingConfirmPage from "./pages/BookingConfirmPage";
import BookingPage from "./pages/BookingPage";
import SimplifiedPropertyRegistrationPage from "./pages/SimplifiedPropertyRegistrationPage";
import AdminApprovalPage from "./pages/AdminApprovalPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import MyBookingsPage from "./pages/MyBookingsPage";
import WishlistPage from "./pages/WishlistPage";
import HostRegistrationPage from "./pages/HostRegistrationPage";
import HostLoginPage from "./pages/HostLoginPage";
import HostSetPasswordPage from "./pages/HostSetPasswordPage";
import HostForgotPasswordPage from "./pages/HostForgotPasswordPage";
import HostResetPasswordPage from "./pages/HostResetPasswordPage";
import HostDashboardPage from "./pages/HostDashboardPage";
import PropertyEditPage from "./pages/PropertyEditPage";
import BlogListPage from "./pages/BlogListPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import BlogEditorPage from "./pages/BlogEditorPage";
import MyBlogsPage from "./pages/MyBlogsPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <GoogleAuthCallback />
          <Header />
          <AdminActingAsHostBanner />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/property/:id" element={<PropertyDetailPage />} />
            <Route path="/property/:id/edit" element={<PropertyEditPage />} />
            <Route path="/booking/:id" element={<BookingPage />} />
            <Route path="/booking/confirm" element={<BookingConfirmPage />} />
            <Route path="/list-property" element={<SimplifiedPropertyRegistrationPage />} />
            <Route path="/host/register" element={<HostRegistrationPage />} />
            <Route path="/host/login" element={<HostLoginPage />} />
            <Route path="/host/set-password" element={<HostSetPasswordPage />} />
            <Route path="/host/forgot-password" element={<HostForgotPasswordPage />} />
            <Route path="/host/reset-password" element={<HostResetPasswordPage />} />
            <Route path="/host/dashboard" element={<HostDashboardPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/approvals" element={<AdminApprovalPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/bookings" element={<MyBookingsPage />} />
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/new" element={<BlogEditorPage />} />
            <Route path="/blog/mine" element={<MyBlogsPage />} />
            <Route path="/blog/:id/edit" element={<BlogEditorPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
          </Routes>
          <Footer />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
